export const API_PERMISSION_PAGES = [
  { key: 'home', label: 'Home' },
  { key: 'executivePanel', label: 'Painel Executivo' },
  { key: 'analytics', label: 'Analytics (uso do produto)' },
  { key: 'users', label: 'Usuários' },
  { key: 'cooperatives', label: 'Cooperativas' },
  { key: 'units', label: 'Unidades' },
  { key: 'equipments', label: 'Equipamentos' },
  { key: 'nir', label: 'Nir' },
  { key: 'logs', label: 'Logs' },
  { key: 'maps', label: 'Mapa' },
  { key: 'mapsunits', label: 'Mapa Unidades' },
  { key: 'charts', label: 'Curvas' },
  { key: 'updates', label: 'Atualizações' },
  { key: 'models3d', label: 'Modelos 3D' },
  { key: 'support', label: 'Suporte' },
  { key: 'supportnir', label: 'Suporte NIR' },
  { key: 'supportdry', label: 'Suporte Dry' },
  { key: 'supportiot', label: 'Suporte Iot' },
  { key: 'supportOrange', label: 'Suporte OrangePi' },
  { key: 'equipmentsQL', label: 'Qualidade' },
  { key: 'equipmentsreplace', label: 'Substituir' },
  { key: 'notifications', label: 'Notificações' },
  { key: 'userspassword', label: 'Gera Senha' },
  { key: 'assistencias', label: 'Assistências' },
  { key: 'general', label: 'Configurações' },
];

export const SGU_PERMISSION_PAGES = [
  { key: 'home', label: 'Home' },
  { key: 'units', label: 'Unidades' },
  { key: 'equipments', label: 'Equipamentos' },
  { key: 'restricted', label: 'Restrito' },
  { key: 'report', label: 'Relatório' },
  { key: 'settings', label: 'Configurações' },
  { key: 'companyData', label: 'Dados da Empresa' },
  { key: 'silosbag', label: 'Silos Bag' },
  { key: 'dryer', label: 'Secador' },
  { key: 'sementeira', label: 'Sementeira' },
  { key: 'rodizio', label: 'Rodízio' },
];

export const APP_PERMISSION_PAGES = [
  { key: 'home', label: 'Home' },
  { key: 'equipmentsreplace', label: 'Substituir Equipamentos' },
];

export const ADMIN_ROLE_OPTIONS = ['MASTER', 'ADMIN', 'MANAGER', 'ASSISTANCE'];

export const normalizeAdmRole = (value) => {
  if (ADMIN_ROLE_OPTIONS.includes(value)) return value;
  if (value === true || value === 'true') return 'ADMIN';
  return '';
};

export const normalizeAssistenciaId = (value) => {
  if (value === null || value === undefined) return '';
  return String(value).trim();
};

const DEFAULT_READ_WRITE = { read: false, write: false };

export const DEFAULT_PERMISSION_ASSIST = {
  home: { ...DEFAULT_READ_WRITE },
  equipmentsreplace: { ...DEFAULT_READ_WRITE },
};

export const DEFAULT_PERMISSION_WEB_ASSISTENCIA = {
  adm: '',
  painelAssistencias: { ...DEFAULT_READ_WRITE },
  certificados: { ...DEFAULT_READ_WRITE },
  senhas: { ...DEFAULT_READ_WRITE },
  cadastros: { ...DEFAULT_READ_WRITE },
};

const mergeReadWritePermissions = (defaults, raw) => {
  const source = raw && typeof raw === 'object' ? raw : {};

  return Object.keys(defaults).reduce((acc, key) => {
    const defaultValue = defaults[key];
    const rawValue = source[key];

    if (
      defaultValue &&
      typeof defaultValue === 'object' &&
      Object.prototype.hasOwnProperty.call(defaultValue, 'read')
    ) {
      acc[key] = {
        ...DEFAULT_READ_WRITE,
        ...(rawValue && typeof rawValue === 'object' ? rawValue : {}),
      };
      return acc;
    }

    acc[key] = rawValue ?? defaultValue;
    return acc;
  }, {});
};

export const normalizePermissionAssist = (raw) =>
  mergeReadWritePermissions(DEFAULT_PERMISSION_ASSIST, raw);

export const normalizePermissionWebAssistencia = (raw = {}) => {
  const { assistencia, ...rawWithoutAssistencia } =
    raw && typeof raw === 'object' ? raw : {};

  return {
    ...mergeReadWritePermissions(DEFAULT_PERMISSION_WEB_ASSISTENCIA, rawWithoutAssistencia),
    adm: normalizeAdmRole(raw?.adm),
  };
};

export const WEB_ASSISTENCIA_PAGES = [
  { key: 'adm', label: 'Administrador', select: true, options: ADMIN_ROLE_OPTIONS },
  { key: 'painelAssistencias', label: 'Painel de Assistências' },
  { key: 'certificados', label: 'Certificados' },
  { key: 'cadastros', label: 'Cadastros' },
  { key: 'senhas', label: 'Senhas' },
];
